(() => {
  'use strict';
  const mq=matchMedia('(max-width:768px)'), reduced=matchMedia('(prefers-reduced-motion:reduce)');
  function init(root){
    if(root.dataset.lmMerchReady)return;
    root.dataset.lmMerchReady='true';
    const configNode=root.querySelector('[data-lm-merch-config]');
    const config=configNode?JSON.parse(configNode.textContent):{};
    const variants=JSON.parse(root.querySelector('[data-variant-json]')?.value||'[]');
    const labels=[...root.querySelectorAll('.lm-pdp-colours input[data-variant-input]')];
    const clean=s=>String(s||'').replace(/^(?:Solid|S|PCH|BQ|BMP|T|V|TR)-/i,'').replace(/^(?:\d+-)+(?:TR-|V-)?/,'').replace(/^\d+-/,'');
    labels.forEach(input=>{const label=input.nextElementSibling;if(label){label.setAttribute('aria-label',clean(input.value));label.title=clean(input.value);}});
    const rail=root.querySelector('.lm-pdp-colours');
    let timer,paused=false;
    const stop=()=>{paused=true;clearInterval(timer);};
    if(rail&&labels.length>1){
      const tools=document.createElement('div');tools.className='lm-merch-rail-tools';
      const hint=document.createElement('span');hint.textContent=labels.length+' '+config.colourLabel;
      const toggle=document.createElement('button');toggle.type='button';toggle.textContent=config.pauseLabel;toggle.setAttribute('aria-pressed','false');
      tools.append(hint,toggle);rail.after(tools);
      function start(){
        clearInterval(timer);
        if(reduced.matches||!config.motion){toggle.hidden=true;return;}
        paused=false;toggle.textContent=config.pauseLabel;toggle.setAttribute('aria-pressed','false');
        let direction=1;const startTime=performance.now();
        timer=setInterval(()=>{
          if(paused||reduced.matches||performance.now()-startTime>10000){clearInterval(timer);return;}
          if(performance.now()-startTime<1800)return;
          const max=mq.matches?rail.scrollHeight-rail.clientHeight:rail.scrollWidth-rail.clientWidth;
          if(max<2){toggle.hidden=true;return;}
          toggle.hidden=false;
          const value=mq.matches?rail.scrollTop:rail.scrollLeft;
          if(value>=max-2)direction=-1;if(value<=0)direction=1;
          const distance=Math.max(.5,Number(config.speed||24)/24);
          if(mq.matches)rail.scrollTop+=direction*distance;else rail.scrollLeft+=direction*distance;
        },45);
      }
      ['pointerdown','pointerenter','focusin','wheel','touchstart'].forEach(event=>rail.addEventListener(event,()=>{stop();toggle.textContent=config.playLabel;toggle.setAttribute('aria-pressed','true');},{passive:true}));
      toggle.addEventListener('click',()=>{if(paused)start();else{stop();toggle.textContent=config.playLabel;toggle.setAttribute('aria-pressed','true');}});
      reduced.addEventListener('change',()=>{stop();toggle.hidden=reduced.matches;});
      start();
    }
    root.querySelector('[data-lm-guide-open]')?.addEventListener('click',()=>root.querySelector('[data-lm-guide]')?.showModal());
    root.querySelector('[data-lm-guide-close]')?.addEventListener('click',()=>root.querySelector('[data-lm-guide]')?.close());
    function current(){
      const inputs=[...root.querySelectorAll('input[data-variant-input]:checked,select[data-variant-input]')];
      return variants.find(v=>inputs.length&&inputs.every(input=>v[input.dataset.index]===input.value))||variants.find(v=>String(v.id)===root.querySelector('[data-product-select]')?.value)||variants[0];
    }
    function update(){
      const variant=current();if(!variant)return;
      const included=root.querySelector('[data-lm-merch-included]');
      let text=config.included;
      const size=String(variant.options?.find(x=>/single|queen|king|emperor|double/i.test(x))||'');
      if(config.handle==='95-comp-giza-cotton-classic-combo')text=/single/i.test(size)?config.singleContents:/emperor/i.test(size)?config.included:config.doubleContents;
      if(config.handle==='percale-blanc-classic-combo')text=/single/i.test(size)?config.singleContents:config.doubleContents;
      if(config.handle==='165-comp-giza-cotton-bedding-duo')text=/single/i.test(size)?config.singleContents:/queen|king/i.test(size)?config.doubleContents:config.included;
      if(config.category==='towels'&&!config.included)text=variant.options.filter((_,i)=>!/colou?r|^type$/i.test(config.optionNames?.[i]||'')).join(' · ')||variant.title;
      if(config.category==='pillows'&&config.handle==='548-1810-lamarvel-memory-foam-pillows-bmp-white')text=variant.options.includes('Pair')?config.doubleContents:config.singleContents;
      if(included)included.textContent=text||variant.title.replace('Default Title',root.dataset.productTitle);
      const personaliser=root.querySelector('.product-personalizer');
      root.classList.toggle('lm-merch-has-personaliser',!!personaliser);
      const compare=root.querySelector('[data-compare-price]');
      const wrap=root.querySelector('[data-product-price-wrap]');
      if(compare&&wrap){const rendered=Number(root.querySelector('[data-product-price]')?.textContent.replace(/[^\d.]/g,''))*100;const valid=Number(variant.compare_at_price)>(rendered||Number(variant.price));wrap.classList.toggle('hide',!valid);compare.hidden=!valid;}
      const label=root.querySelector('[data-lm-merch-colour]');
      if(label){const colour=labels.find(input=>input.checked);label.textContent=colour?clean(colour.value):'';}
    }
    root.addEventListener('change',()=>{stop();requestAnimationFrame(update);setTimeout(update,150);});
    document.addEventListener('variant:change',()=>requestAnimationFrame(update));
    const priceNode=root.querySelector('[data-product-price]');
    if(priceNode)new MutationObserver(()=>requestAnimationFrame(update)).observe(priceNode,{childList:true,subtree:true,characterData:true});
    update();
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))clearInterval(timer);},{once:true});
  }
  function boot(){document.querySelectorAll('[data-lm-merch="true"]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
